import type { AxiosInstance } from 'axios';
import { createCrudService, type CrudService } from '../core/crud';
import type { PriceList, PriceListCreate, PriceListFilter } from '../data/priceList';

export function createPriceListService(client: AxiosInstance) {
  return createCrudService<PriceList, PriceListCreate, PriceListFilter>(
    client,
    '/master-data/PriceList',
    'id',
  );
}

export type PriceListService = CrudService<PriceList, PriceListCreate, PriceListFilter>;
